<template>
  <div class="basic-block block-updateinfo">
    <h3 class="block-updateinfo__title"><img src="/static/img/recommend/lp/kurenotori/updateinfo_title.png" alt="更新情報"></h3>
    <update-info-item
      :color-scheme="colorScheme"
      :update-list="item"
      :idx="idx"
      :lp-id="lpId"
      v-for="(item,idx) in  updateListMod" :key="idx"    
      />
  </div>
</template>

<script>
import UpdateInfoItem from '@/utvStore/components/recommend/lp/partials/UpdateInfoItem'


const TEMP_DATA =[
        {
          title: '占いメニュー追加',
          desc: '月額会員限定：「運勢バイオリズム」「この次注目の幸運日」',
          date:'2022-10-10'
        },
        {
          title: '占いメニュー2本追加',
          desc: '月額会員限定：梅花心易「次の出来事」「相手の気持ちと恋の未来」',
          date:'2022-10-10'
        },
      ]
  

export default {
  name: 'BlockUpdateInfo',
  components: {
    UpdateInfoItem,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
    lpId: {
      type: Number,
      default: 0
    },

    
  },
  data() {
    return {
      
    }
  },
  computed: {
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    
    updateListMod(){
      return TEMP_DATA
    }
  
  },
  methods: {
    clicked() {
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-updateinfo {
    background: #fff;
    padding: 20px;
    padding-bottom: 60px;
    padding-top: 60px;
    &__title{
      margin: auto;
      width: 142px;
      margin-bottom:8px;
      img{
        width: 142px;
      }
    }
}

.block-faq {
  padding: 48px 20px 40px;
  background: #F7F7F7;
  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 28px;
  }
  &__list {
    margin: 0 0 28px;
    dt {
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      text-align: justify;
      color: $l_col_keycolor;
      margin: 0 0 8px;
    }
    dd {
      font-size: 14px;
      line-height: 21px;
      text-align: justify;
      margin: 0;
      + dt {
        margin-top: 24px;
      }
    }
  }
  &__btn {
    max-width: 270px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockUpdateInfo.vue